var _linearGradient, _path, _linearGradient2, _polygon, _polygon2, _polygon3, _path2, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jOxEAtqKLV9JfRrHHmqLMa",
    x1: 3.381,
    x2: 44.593,
    y1: 25.73,
    y2: 25.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33c481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21a366"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jOxEAtqKLV9JfRrHHmqLMa)",
    d: "M23.987,17l-5.094-8.727C18.795,8.104,18.614,8,18.418,8H3.931 C3.507,8,3.243,8.46,3.457,8.827l20.056,34.36c0.212,0.363,0.737,0.363,0.949,0l20.056-34.36C44.731,8.46,44.467,8,44.043,8H29.556 c-0.195,0-0.376,0.104-0.475,0.273L23.987,17z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jOxEAtqKLV9JfRrHHmqLMb",
    x1: 11.146,
    x2: 36.828,
    y1: 19,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#313437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45494d"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#jOxEAtqKLV9JfRrHHmqLMb)",
    points: "29.24,8 23.987,17 18.734,8 11.146,8 23.987,30 36.828,8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "23.987,30 36.828,8 29.24,8 23.987,17 18.734,8 11.146,8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "28.082,8 19.892,8 23.987,15.016"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.26,8.252l-12.841,22l-0.432,0.74l-0.432-0.74l-12.841-22L10.567,8H9.988l0.294,0.504l12.841,22 l0.864,1.48l0.864-1.48l12.841-22L37.986,8h-0.579L37.26,8.252z M36.828,9h0.005H36.828z",
    opacity: 0.05
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "36.828,8 23.987,30 11.146,8 10.567,8 10.714,8.252 23.555,30.252 23.987,30.992 24.419,30.252 37.26,8.252 37.407,8 36.833,8",
    opacity: 0.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.106cfd94dfde71c5f6010885d13fdd7e.svg";
export { ForwardRef as ReactComponent };